import React from 'react';
import BottomSheet from 'components/BottomSheet';
import Icon from 'components/Icon';
import Form from './Form';

type AppProps = {
  open: boolean;
  docId: string;
  closeModal: () => any;
};

const EmailDoc: React.FC<AppProps> = ({ open, docId, closeModal }) => {
  return (
    <BottomSheet open={open} maxWidth="max-w-2xl">
      <div className="pb-4">
        <div className="flex justify-between">
          <div className="page-heading">Email Document</div>
          <div>
            <Icon
              name="close"
              size={32}
              onClick={closeModal}
              className="cursor-pointer"
            />
          </div>
        </div>
      </div>
      {open && <Form docId={docId} onSuccess={closeModal} />}
    </BottomSheet>
  );
};

export default EmailDoc;
